module.exports = __webpack_public_path__ + "img/banner_wuhan.e80ee045.png";